import { Component, OnInit } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { OrganizationType } from "../../types/app.step.type";
import { OrganizationsSelectionComponent } from "../../components/organizations-selection/organizations-selection.component";
import { PAGE_ROUTES } from "../../constants";
import { NgIf } from "@angular/common";

@Component({
  selector: "app-organizations",
  standalone: true,
  imports: [
    NgIf,
    ReactiveFormsModule,
    OrganizationsSelectionComponent,
  ],
  templateUrl: "./organizations.component.html",
  styleUrl: "./organizations.component.scss"
})
export class OrganizationsComponent implements OnInit {
  protected organizations: OrganizationType[] = [];
  protected pendingToken = '';
  protected redirectUri = ''

  constructor(
    private _route: ActivatedRoute,
    private _router: Router
  ) { }

  ngOnInit(): void {
    this._route.queryParamMap.subscribe((params) => {
      const organizationsJson = params.get("organizations")
      const pendingToken = params.get("pendingToken")
      const redirectUri = params.get("redirectUri")

      if (pendingToken && redirectUri && organizationsJson) {
        this.pendingToken = pendingToken
        this.redirectUri = redirectUri
        this.organizations = organizationsJson ? JSON.parse(organizationsJson) : null
      } else {
        this._router.navigate([PAGE_ROUTES.HOME])
      }
    });
  }
}